import { getAllFiles } from './getAllFiles'
import { getInputName } from './getInputName'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function getFiles (fieldId, formId) {
  const allFiles = getAllFiles(formId)
  const inputName = getInputName(fieldId)

  if (typeof allFiles[inputName] === 'undefined') {
    allFiles[inputName] = []
  }

  return allFiles[inputName]
}
